import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/mainServices/session';

export const kycOnboardingGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.getCurrentUser()?.kyc?.nationlity) {
    return router.createUrlTree(['/main/home']);
  }

  return true;
};
